export const LIST_CUSTOMERS_SLICE = "listCustomersSlice";
export interface IListCustomersSlice {
  isGot: boolean;
  customers: ICustomer[];
}
export interface ICustomer {
  _id: string;
  fullName: string;
  shortName: string;
  majorPhone: string;
  minorPhone: string;
  email: string;
  frontCID: string;
  backCID: string;
  fullNameNoAccent: string;
  shortNameNoAccent: string;
  address: string;
}

export const CUSTOMERS_URL = "/customers";
